<script>
    import { onMount } from "svelte";
    import { ICONS } from "../js/icons";
    import backend from "../server";
    import Toaster from '../lib/components/modals/freebets/novus/Toaster.svelte';
   
    import moment from 'moment';
   
    import Form from "../lib/components/modals/freebets/endorphina/Form.svelte";
    let isNew = false;
    let showFilters = false; 
    let isLoading = false;
    let isShowToast = false;
    let toastMessage = '';
     let toastType = ''; 
    let filters = { currency: '', nodeId: 1072, player: '', state:'',search:'' }
    const currencies = [
    { value: 'USD', label: 'Dólar' },
    { value: 'EUR', label: 'Euro' },
    { value: 'MXN', label: 'Peso Mexicano' }
  ];

  let players = [
    { id: 28531, player_id: 18725557, username:'3892419797047',user: 'CARLOS' },
    { id: 18, player_id: 99999999, username:'7044203852523',user: 'Henry' },
    { id: 3, player_id: 99999999, username:'0411443323207',user: 'carlosUSD' },
    { id: 28532, player_id: 99999999,username: '2860967228690', user: 'VTX' },
    { id: 28531, player_id: 99999999,username: '0336631693205', user: 'MAKANO' },
   
  ];
    let statusMap = {
    EXPIRED: { label: "Expirado", class: "bg-danger text-white" },
    INIT: { label: "Inicializado", class: "bg-warning text-dark" },
    COMPLETED: { label: "Completado", class: "bg-success text-white" },
    DELETED: { label: "Eliminado", class: "bg-secondary text-white" },
    ACTIVE: { label: "Activo", class: "bg-primary text-white" }
  };

    let bonus = {
        id: "",
        name: "FS10",
        player: "",
        nodeId: 1072,
        currency: "USD",
        game: "",
        sign: "",
        spins: {
          amount: 10,
          played: 0,
          totalBet: 100
        },
        state: "INIT",
        created: "",
        expires: "",
        bonusBet: 0,
        bonusWin: 0
  };

  let bonuses=[];
   
    const created = () => {
        isNew = true;
    };
    const searchEnter = (e) => {
      if (e.charCode === 13);
    };
    const toggleFilters=()=>{
      showFilters = !showFilters;
    }
    onMount(async () => {
      listCampaign()
     });
    const listCampaign = async () => {
      let params = { ...filters };
      isLoading = true; 
        try {
         let response = await backend.freespin.getEndorphina(filters);
         console.log("----",response)
         bonuses =response.data
        } catch (error) {
          console.error("Error al obtener las campañas:", error);
         
        } finally {
          isLoading = false; 
        }

    };
    const remove = async (bonusId) => {
      try {
         let response = await backend.freespin.deletEndorphina({nodeId:filters.nodeId,id:bonusId});
         if(response.status){
          showToast()
          listCampaign()
         }
        } catch (error) {
          showToast('¡Algo salió mal!', error.message);
        
        } finally {
          isLoading = false; 
        }
  };
  const formatDate = (dateStr) => {
    return dateStr ? moment(dateStr).format('DD/MM/YYYY HH:mm') : 'Sin fecha';
  };
  const showToast = (message = 'Operación exitosa', type = 'success') => {
    toastMessage = message;
    toastType = type;
    isShowToast = true;
  }
  
  </script>
  
  <div class="wrapp">
    <div class="menu-filter">
      <div style="display: flex; flex-direction: row; gap: 0.5rem; margin-top: 1rem;">
  
        <input
          on:keypress={searchEnter}
          bind:value={filters.search}
          class="form-control"
          placeholder="Buscar"
          style="flex: 1;" 
        />
        <button
        on:click={listCampaign}
        class="btn btn-pink btn-sm"
        title="Buscar"
        disabled={isLoading} >
        {#if isLoading}
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cargando...
        {:else}
          {@html ICONS.search}
        {/if}
      </button>
        <button class="btn btn-pink btn-sm" on:click={created}>
          {@html ICONS.add}
        </button>
        <button class="btn btn-pink btn-sm" on:click={toggleFilters}>
          <i class="fa-solid {showFilters ? 'fa-filter-circle-xmark':'fa-filter'}"></i>
        </button>
      </div>
    </div>
    </div>
    {#if showFilters}
    <div class="wrapp">
      <div class="menu-filter_">
        <div class="filters-container">
          <div class="row">
            <!-- Currency select -->
            <div class="col-md-3">
              <label for="currency">Moneda</label>
              <select id="currency" bind:value={filters.currency} class="form-control">
                <option value="">TODOS</option>
                 {#each currencies as currency}
                  <option value={currency.value}>{currency.label}</option>
                {/each}
              </select>
            </div>
    
            <!-- Player select -->
            <div class="col-md-3">
              <label for="player">Jugador</label>
              <select id="player" bind:value={filters.player} class="form-control">
                <option value="">TODOS</option>
                {#each players as player}
                  <option value={player.username}>{player.user}</option>
                {/each}
              </select>
            </div>
    
            <!-- nodeId input disabled -->
            <div class="col-md-3">
              <label for="nodeId">Node ID</label>
              <input type="number" id="nodeId" bind:value={filters.nodeId} class="form-control" disabled />
            </div>
    
            <!-- State select -->
            <div class="col-md-3">
              <label for="state">Estado</label>
              <select id="state" bind:value={filters.state} class="form-control">
                <option value="">TODOS</option>
                {#each Object.entries(statusMap) as [key, state]}
                  <option value={key}>{state.label}</option>
                {/each}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/if}
    <div class="wrapp">
      <div class="container-table">
        <div style="overflow-x: auto;">
          {#if isLoading}
          <p>Cargando...</p>
        {:else}
          {#if bonuses.length > 0}
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>N°</th>
                  <th>Identificador</th>
                  <th>Juego</th>
                  <th>Jugador</th>
                  <th>Moneda</th>
                  <th>Type</th>
                  <th>Create Time</th>
                  <th>Fecha Exp.</th>
                  <th>Estado</th>
                  <th colspan="2">Action</th>  
                </tr>
              </thead>
              <tbody>
                {#each bonuses as bonus, index}
                  <tr>
                    <td>{index + 1}</td> 
                    <td>{bonus.id}</td>
                    <td>{bonus.game}</td>
                    <td>{bonus.player}</td>
                    <td>{bonus.currency}</td>
                    <td>{bonus.game ? 'Free Spins' : 'N/A'}</td>
                    <td>{formatDate(bonus.created)}</td>
                    <td>{formatDate(bonus.expires)}</td>
                    <td>
                      <span class={`badge ${statusMap[bonus.state]?.class || 'bg-dark text-white'}`}>
                        {statusMap[bonus.state]?.label || 'Desconocido'}
                      </span>
                    </td>
                    <td><button class="btn btn-sm btn-danger" on:click={() => remove(bonus.id)} >Eliminar</button></td>
                  </tr>
                {/each}
              </tbody>
            </table>
          {:else}
            <p>No se encontraron registros.</p>
          {/if}
        {/if}
        
          
          
        </div>
      </div>
    </div>
    {#if isNew}
    <Form bind:isNew bind:bonus {listCampaign} {players} />
  {/if}
  <Toaster  bind:message={toastMessage} bind:type={toastType} bind:show={isShowToast} />

  <style>
    .menu-filter {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
      padding: 0.5rem;
    }
    .filters-container {
    margin-top: 1rem;
    border: 1px solid #ddd;
    padding: 1rem;
    border-radius: 5px;
  }
  .button-container {
    display: flex;
    gap: 10px; /* Esto crea un margen de 10px entre los botones */
  }
  
    .btn-pink {
     background-color: #2a1a28;
      color: white;
    }
    .btn-pink:hover{
        background-color: #FF0090;
      color: white;
    }
    .wrapp {
    padding: 10px;
    margin: 0;
  }
  
  .menu-filter {
    margin: 0;
    padding: 0;
  }
  
 
  </style>